import React from 'react';
import { useStyletron } from 'baseui';

export const ButtonLayout = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const [css, theme] = useStyletron();
  return (
    <div
      className={css({
        marginTop: theme.sizing.scale300,
        marginBottom: theme.sizing.scale300,
      })}
    >
      {children}
    </div>
  );
};
